var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"handsonTable-wrapper"},[_c('div',{ref:"example1",staticClass:"hot handsontable htRowHeaders htColumnHeaders",staticStyle:{"height":"320px","overflow":"hidden","width":"100%"},attrs:{"data-originalstyle":"height: 320px; overflow: hidden; width: 100%;"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }